import { RouteSelected } from './core/config';

const Routes = (history) => RouteSelected(history);

export default Routes;
